const snakeToCamelCase = (str) =>
  str
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace('-', '').replace('_', '')
    );

export const formatSurveyDataToCamel = (surveyData) => {
  const formattedSurveyData = {};

  for (const [key, value] of Object.entries(surveyData)) {
    const camelCaseKey = snakeToCamelCase(key);
    formattedSurveyData[camelCaseKey] = value;
  }

  return formattedSurveyData;
};

//handle redirect back to dashboard after save. OG function pre 2025 epic updates
export const sectionRedirect = (respondentId) =>
  window.location.assign(
    `/sales-report-portal/dashboard/${
      respondentId ? '?respondent_id=' + respondentId : ''
    }`
  );

//handle redirecting the user to the next sequential section instead of the dashboard
export const continueSectionRedirect = (respondentId, surveyId, sectionId) => {
  const sequentialSectionId = Number(sectionId) + 1;

  if (respondentId && sectionId && sequentialSectionId) {
      window.location.assign(
        `/sales-report-portal/section-${sequentialSectionId}/?respondent_id=${respondentId}&survey_id=${surveyId}`
      )
    } else if (respondentId && (!sectionId || !sequentialSectionId)) {
      window.location.assign(
        `/sales-report-portal/dashboard${
          respondentId ? '?respondent_id=' + respondentId : ''
        }`
    )};
};

// prepare body of request for State Survey Portion for api
export const formatStatesDataForWrite = (statesData) => {
  if (Array.isArray(statesData)) {
    const formattedStatesData = statesData.map((stateData) => {
      return {
        statePortionId: stateData.id,
        data: extractStateInfo(stateData)
      };
    });

    return formattedStatesData;
  } else {
    return {
      statePortionId: statesData.id,
      data: extractStateInfo(statesData)
    };
  }
};

// succinct data prep for `formatStatesDataForWrite`
const extractStateInfo = (stateInfo) => {
  const formattedStateInfo = {};
  const ignoreList = ['id', 'createdAt', 'updatedAt', 'surveyId', 'state'];

  for (const [key, value] of Object.entries(stateInfo)) {
    if (value === null) {
      formattedStateInfo[key] = null;
    } else if (key === 'accountsByState') {
      formattedStateInfo[key] = value;
    } else if (!ignoreList.includes(key)) {
      formattedStateInfo[key] = parseInt(value);
    }
  }

  return { ...formattedStateInfo };
};

// based on StateItem component, `isAltForm` boolean, remove unneeded values
export const setNullValueForFieldsBasedOnAltForm = (
  stateInfo,
  isAltForm,
  forAcquisitions
) => {
  if (forAcquisitions === undefined) return stateInfo;

  const ignoreList = ['id', 'createdAt', 'updatedAt', 'surveyId', 'state'];

  return isAltForm
    ? handleAltForm(stateInfo, forAcquisitions, ignoreList)
    : handleRegularForm(stateInfo, forAcquisitions, ignoreList);
};

const handleAltForm = (stateInfo, forAcquisitions, ignoreList) => {
  const cleanedStateInfo = {};

  for (const [key, value] of Object.entries(stateInfo)) {
    if (!ignoreList.includes(key)) {
      cleanedStateInfo[key] = key.match(/NumberOfAccounts/) ? null : value;
    } else {
      cleanedStateInfo[key] = value;
    }

    if (key === 'accountsByState') {
      cleanedStateInfo[key] = true;
    }

    if (key === 'percentFromAcquisitions') {
      cleanedStateInfo[key] = forAcquisitions ? value : null;
    }

    if (key === 'totalAccountsByState') cleanedStateInfo[key] = value;
  }

  return cleanedStateInfo;
};

const handleRegularForm = (stateInfo, forAcquisitions) => {
  const cleanedStateInfo = {};

  for (const [key, value] of Object.entries(stateInfo)) {
    cleanedStateInfo[key] = value;

    if (key === 'accountsByState') {
      cleanedStateInfo[key] = false;
    }

    if (key === 'percentFromAcquisitions') {
      cleanedStateInfo[key] = forAcquisitions ? value : null;
    }

    if (key === 'totalAccountsByState') cleanedStateInfo[key] = null;
  }

  return cleanedStateInfo;
};

// Set disabled status on section button based on latestSectionCompleted
export const disableSectionItem = (sectionId, latestSectionCompleted) => {
  switch (sectionId) {
    case 1:
      return false;
    case 2:
      return latestSectionCompleted >= 1 ? false : true;
    case 3:
      return latestSectionCompleted >= 2 ? false : true;
    case 4:
      return latestSectionCompleted >= 3 ? false : true;
    case 5:
      return latestSectionCompleted >= 4 ? false : true;
  }
};

export const convertToTitleCase = (str) => {
  if (str) {
    const stringArray = str
      .split(' ')
      .map(
        (substring) =>
          `${substring[0].toUpperCase()}${substring.slice(1, substring.length)}`
      );
    return stringArray.join(' ');
  }

  return str;
};
